export default {
  title:
    "Alla Terrazza,<br /> dove il gusto incontra il paesaggio<br class='hide-for-small' /> e la tradizione si fa sapore.",
  chapter1: {
    title: 'La terrazza<br/> di Valdobbiadene',
    text: 'Alla Terrazza, dove il gusto incontra il paesaggio e la tradizione si fa sapore, ti aspetta un luogo storico incastonato tra le colline di Valdobbiadene. La nostra osteria è da sempre punto di incontro per chi cerca autenticità: un angolo senza tempo dove il panorama mozzafiato abbraccia le vigne e il ritmo lento della natura accompagna ogni brindisi. Un’esperienza che unisce la bellezza del territorio alla calda ospitalità di una volta.',
  },
  chapter2: {
    title: 'Vini e cucina<br/> dei colli del Prosecco',
    text: 'Alla Terrazza il bicchiere parla la lingua delle nostre colline: serviamo i migliori vini locali, dal Prosecco fresco e fragrante alle etichette più ricercate del territorio. La cucina, curata e genuina, porta in tavola i piatti tipici della tradizione veneta, con ingredienti selezionati e ricette che profumano di casa. Un equilibrio perfetto tra calice e forchetta, per un viaggio che esalta i sapori autentici e il piacere della convivialità.',
  },
  chapter3: {
    title: 'Tra colline e Dolomiti',
    text: 'Alla Terrazza, ogni sguardo si perde tra i filari del Prosecco, patrimonio UNESCO, e l’orizzonte che guarda alle Dolomiti e a Venezia. Un territorio unico, fatto di panorami suggestivi e di una cultura enogastronomica che racconta secoli di storia. Qui, tra natura e tradizione, il tempo sembra fermarsi per lasciare spazio alle emozioni più vere: un luogo che vive della sua terra e che invita a scoprirla, calice dopo calice.',
  },
  altInterno: "Interno dell'Osteria alla Terrazza a Valdobbiadene",
  altOste: "L'oste dell'Osteria alla Terrazza",
  altAperitivo:
    "Aperitivo con Prosecco di Valdobbiadene all'Osteria alla Terrazza",
  altUova: 'Illustrazione di uova sode, cucina tipica veneta',
  altProsecco:
    'Vista sui vigneti delle Colline del Prosecco UNESCO da Valdobbiadene',
  banner: {
    title: 'Dopo l’aperitivo, il piacere continua',
    text: 'Concludi la tua serata in bellezza: a pochi passi da qui ti aspetta Locanda Solagna, con una cucina che celebra il territorio e un’accoglienza autentica.',
    cta: 'Scopri la locanda',
  },
}
